import PropTypes from "prop-types";
import { Bot } from "lucide-react";
import UserAvatar from "../people/UserAvatar";

/**
 * Says, on every page, that the browser is signed in as an agent.
 *
 * Without it a screenshot of an agent run is indistinguishable from a
 * person's, which is the confusion this whole feature exists to prevent:
 * the agent has its own account precisely so "who did this" stays
 * answerable.
 */
function AgentSessionBanner({ me }) {
  const { username } = me;
  // A notice, not a third nav row (board #72): inset in the page column
  // with space above it, an edge and an icon — the full-bleed tan strip
  // directly under the tan sub-nav read as more navigation.
  return (
    <div className="page-container mt-3">
      <div
        className="flex items-center gap-2 rounded-md border border-l-4 border-warning/50 border-l-warning bg-warning/15 px-3 py-2 font-sans text-sm text-foreground"
        role="status"
      >
        <Bot className="size-4 shrink-0 text-warning" aria-hidden="true" />
        <p className="m-0">
          Signed in as{" "}
          <UserAvatar
            user={me}
            size="xs"
            decorative
            className="mr-1 align-text-bottom"
          />
          <strong>{username}</strong>, an agent. Everything done here is
          recorded as {username}, not as a person.
        </p>
      </div>
    </div>
  );
}

AgentSessionBanner.propTypes = {
  me: PropTypes.shape({
    username: PropTypes.string.isRequired,
    avatar_url: PropTypes.string,
  }).isRequired,
};

export default AgentSessionBanner;
